var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    width: 50,
    height: 50,
    rx: 5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 14.79 30.4212 12.5 25 12.5C19.5788 12.5 15 14.79 15 17.5V20C15 22.71 19.5788 25 25 25C30.4212 25 35 22.71 35 20V17.5ZM25 33.75C19.5788 33.75 15 31.46 15 28.75V32.5C15 35.21 19.5788 37.5 25 37.5C30.4212 37.5 35 35.21 35 32.5V28.75C35 31.46 30.4212 33.75 25 33.75Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.5C35 25.21 30.4212 27.5 25 27.5C19.5788 27.5 15 25.21 15 22.5V26.25C15 28.96 19.5788 31.25 25 31.25C30.4212 31.25 35 28.96 35 26.25V22.5Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectDataIcon);
export default __webpack_public_path__ + "static/media/connect-data-icon.37aa064768cd897105b8ec3c8e679e1b.svg";
export { ForwardRef as ReactComponent };